import { Dayjs } from 'dayjs';

export type RangeValueType = [Dayjs | null, Dayjs | null];

export interface CountryType {
  id: number;
  name: string;
  iso_code: string;
}

export interface AreaType {
  id: number;
  name: string;
}

export interface CompanyType {
  id: number;
  name: string;
}

export interface SourceType {
  id: number;
  name: string;
}

export enum DiscountType {
  PERCENT = 'percent',
  AMOUNT = 'amount'
}
